import React from 'react';
export function ClickIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4a1 1 0 00-1 1v7.5a1 1 0 01-1.707.707l-2.25-2.25c-.3-.3-.786-.3-1.086 0-.292.293-.315.8.002 1.147A46.556 46.556 0 017.857 17h12.15v-6.5a1.003 1.003 0 00-2.002-.104c.002.034.002.069.002.104a1 1 0 01-1 1H17a1 1 0 01-1-1c0-.035 0-.07.002-.104A1.004 1.004 0 0014 10.5a1 1 0 01-1 1h-1a1 1 0 01-1-1V5a1 1 0 00-1-1zm10.007 15H9.132c.21.363.39.7.533 1h10.342v-1zM9.023 22a.997.997 0 01-.978-.702c-.18-.525-.795-1.646-1.793-3.102a44.512 44.512 0 00-3.769-4.743c-1-1.094-1.028-2.822.06-3.91a2.768 2.768 0 013.914 0l.543.543V5a3 3 0 016 0v3.266a2.996 2.996 0 012.004-.766c.767 0 1.468.288 2 .762a3.003 3.003 0 015.004 2.238V21a1 1 0 01-1 1H9.022z"
  }));
}